/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
/* eslint-disable */
import moment from 'moment';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useEffect, useState } from 'react';
import styles from './BillsListing.module.scss';
import { addCommas, classes, getActionColumn } from '../../Helpers';
import { ListTable } from '../ListTable';
import { urls } from '../../Constants';
import { Button } from '../ui/button';
import { useAuth } from '../Auth/Login/auth';
import userRolesAndPermissions from '@/Services/userRolesAndPermissions.services';
import { notificationServices } from '@/Services';
import authActions from '@/Actions/auth.actions';
import { connect } from 'react-redux';
import { creditDebitDelta } from '../../Helpers/utils';

const TABLE_COLUMNS = [
	{
		title: 'Bill Id',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Vendor',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Bill Type',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Billing Store',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Order id',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Created By',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Created At',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Bill date',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Due Date',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Bill Amount',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Paid Amount',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Payment Mode',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Reference No',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Payment Date',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Status',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'L1 Action By',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'L2 Action By',
		config: {
			type: 'DATA',
		},
	},
];

const BASE_COLUMNS = [
	{
		title: 'GRN Id',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'View More',
		config: {
			type: 'DATA',
		},
	},
];

const ADDITIONAL_COLUMNS = [
	{
		title: 'Bill Actions',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'MORE',
		config: {
			type: 'DATA',
		},
	},
];

const orderColumns = ['GRN Id', 'Bill Actions', 'View More', 'MORE'];

const COLMAP = {
	'Bill Type': 'id',
	Vendor: 'vendorName',
	Store: 'fromStoreName',
	'Billing Store': 'storeName',
	'Order id': 'clientOrderId',
	'Created By': 'initiatedByUserDisplayName',
	'Created At': 'createdAt',
	'Bill Id': 'clientTransactionId',
	'Due Date': 'dueDate',
	'Bill date': 'transactionDate',
	'Bill Amount': 'finalTransactionAmount',
	'Order Amount': 'orderAmount',
	'Paid Amount': 'currentAmount',
	// Payment columns render from billPaymentsMap (keyed by bill row id), so they map to
	// 'id' the same way 'Status' and 'Bill Type' do — the special renderer gets the id.
	'Payment Mode': 'id',
	'Reference No': 'id',
	'Payment Date': 'id',
	'L1 Action By': 'l1ActionByUserDisplayName',
	'L2 Action By': 'l2ActionByUserDisplayName',
	'GRN Id': 'id',
	// 'Payment Made': '',
	Status: 'id',
};

const BillsListing = (props) => {
	const {
		BILLS,
		vendors,
		userPermissions,
		// togglePaymentModal,
		toggleFileUploaderModal,
		togglePOItemsModal,
		toggleAlert,
		handleCancelBill,
		selectedBills,
		setSelectedBills,
		moreOptionsList,
		viewMoreOptionsList,
		handleBulkPayment,
		pushPoInformation,
		excludedColumns = [],
		externalColumns = [],
		externalSpecialItems = {},
		billPaymentsMap = {},
		openRecordPaymentModal,
		hideExport = false,
		allowCheckList = false,
		showTotal = true,
		showBtnContainer = true,
	} = props;
	const history = useHistory();
	const { appConfig = {}, userConfig = {} } = useAuth();
	const { level } = userConfig?.userDetails || {};
	const levels = [3, 4];
	const { userRolesDict } = userConfig || {};
	const userRoles = Object.values(userRolesDict ?? {}).map((role) => role?.toLowerCase()?.replace(/\s+/g, ''));
	const isInternal = userRoles.includes('internal') || userRoles.includes('cxooffice');
	// Recording a payment is restricted to Internal, Finance and CXO Office.
	const canRecordPayment = isInternal || userRoles.includes('finance');


	const isCreditDocUploadPending = (item) => {
		return (Math.abs(Number(item?.invoiceAmount) - Number(item?.finalTransactionAmount)) > creditDebitDelta) && !item?.extraData?.poClosingData?.creditDoc
	}

	const grnBillApproval = appConfig?.grnBillApproval;
	const SPECIAL_ITEMS = {
		'Bill Id': (clientTransactionId, item) => {
			const billId = clientTransactionId ?? item?.id ?? '-';
			if (!pushPoInformation) {
				return billId;
			}
			const vendorDetails = vendors?.find((ele) => {
				return ele?.id === item?.vendorId;
			});
			return (
				<span
					role='button'
					tabIndex={0}
					className='cursor-pointer'
					style={{ color: '#2563eb', textDecoration: 'underline' }}
					onClick={(e) => {
						e.stopPropagation();
						pushPoInformation(item, vendorDetails, false);
					}}
				>
					{billId}
				</span>
			);
		},
		'Bill date': (date) => {
			return moment(date)?.format('DD-MM-YYYY');
		},
		'Due Date': (date) => {
			return moment(date)?.format('DD-MM-YYYY');
		},
		'Created At': (date) => {
			return moment(date)?.format('DD-MM-YYYY');
		},
		'Bill Type': (id) => {
			const item = BILLS?.find((ele) => {
				return ele?.id === id;
			});
			const type = item?.subType;
			return (
				<div className={classes(styles.type, styles?.[type])}>
					{type}
				</div>
			);
		},
		'Bill Amount': (amount) => {
			return '\u20B9' + addCommas(amount);
		},
		'Paid Amount': (amount) => {
			return `₹${addCommas(amount)}`;
		},
		// The three payment columns show the most recent payment on the bill; the full
		// history lives behind MORE > View Payment Info.
		'Payment Mode': (id) => {
			const latest = billPaymentsMap?.[id]?.latestPayment;
			if (!latest) {
				return '-';
			}
			const count = billPaymentsMap?.[id]?.paymentCount ?? 0;
			return (
				<div className='flex flex-col'>
					<span>{latest?.paymentMode?.split('_')?.join(' ')}</span>
					{count > 1 && (
						<span style={{ color: '#0006', fontSize: '.75rem' }}>
							+{count - 1} more
						</span>
					)}
				</div>
			);
		},
		'Reference No': (id) => {
			return billPaymentsMap?.[id]?.latestPayment?.referenceNumber || '-';
		},
		'Payment Date': (id) => {
			const latest = billPaymentsMap?.[id]?.latestPayment;
			return latest?.paymentDate
				? moment(latest.paymentDate).format('DD-MM-YYYY')
				: '-';
		},
		Status: (transactionId) => {
			const item = BILLS?.find((ele) => {
				return ele?.id === transactionId;
			});
			if (item?.transactionStatus === 'REJECTED') {
				return (
					<div>
						<p>
							{item?.transactionStatus}
							{item?.description
								? ` (Reason: ${item?.description})`
								: ''}
						</p>
						<p className={styles.reupload}>Re-Upload Invoice</p>
					</div>
				);
			}
			if (item?.transactionStatus === 'APPROVAL_PENDING_MANAGER' && isCreditDocUploadPending(item)) {
				return <span className='text-sm '>Credit/Debit doc upload pending</span>
			}
			return item?.transactionStatus?.split('_')?.join(' ');
		},
		'Action by': (transactionId) => {
			const item = BILLS?.find((ele) => {
				return ele?.id === transactionId;
			});
			if (item?.transactionStatus === 'APPROVAL_REJECTED') {
				return (
					<div>
						<p
							style={{
								color: '#0006',
								fontSize: '.75rem',
							}}
						>
							Rejected by
						</p>
						<p>{item?.l1ActionByUserDisplayName}</p>
					</div>
				);
			}

			if (item?.l2ActionByUserDisplayName) {
				return (
					<div>
						<p
							style={{
								color: '#0006',
								fontSize: '.75rem',
							}}
						>
							Approved By
						</p>
						<p>{item?.l2ActionByUserDisplayName}</p>
					</div>
				);
			}
			return (
				<div>
					<p
						style={{
							color: '#0006',
							fontSize: '.75rem',
						}}
					>
						Created By
					</p>
					<p>{item?.l1ActionByUserDisplayName}</p>
					<p />
				</div>
			);
		},
		'GRN Id': (id) => {
			const item = BILLS?.find((ele) => {
				return ele?.id === id;
			});
			return item?.parentTransactionRecord?.clientTransactionId || item?.parentRowId;
		},
		'Bill Actions': (id) => {
			const item = BILLS?.find((ele) => {
				return ele?.id === id;
			});
			const vendorDetails = vendors?.find((ele) => {
				return ele?.id === item?.vendorId;
			});
			const isTransactionCancelled =
				item?.transactionStatus === 'CANCELLED';
			const isTransactionUnPaid = item?.transactionStatus === 'UNPAID';
			const isTransactionRejected =
				item?.transactionStatus === 'REJECTED';
			// eslint-disable-next-line no-unused-vars
			const isTransactionPaid = item?.transactionStatus === 'PAID';
			// const isAdvanceBill = !item?.parentRowId;

			if (isTransactionCancelled) {
				return '-';
			}

			// if (item?.isApproved && isTransactionPaid) {
			// return 'Paid';
			// }
			const creditDocUploadPending = isCreditDocUploadPending(item)
			return (
				<div className='flex flex-col gap-1 min-w-[150px]'>
					{canRecordPayment &&
						['UNPAID', 'PARTIALLY_PAID', 'PENDING'].includes(
							item?.transactionStatus
						) && (
						<Button
							onClick={() => {
								openRecordPaymentModal?.(item);
							}}
							className='primary-btn w-full'
						>
							Record Payment
						</Button>
					)}
					{item?.isApproved &&
						isTransactionUnPaid &&
						!userRoles.includes('finance') && <p>Not paid</p>}
					{item?.isApproved && isTransactionPaid && <p>Paid</p>}
					{/* {item?.isApproved &&
						!isTransactionPaid &&
						userPermissions.FINANCE && (
						<Button
							onClick={() => {
								togglePaymentModal(true, {
									heading: `Make Payment of Bill #${id} ${
											!item?.parentRowId
												? '(Advance Bill)'
												: ''
										}`,
									// totalAmount: item['Bill Amount'],
									type: 'paymentMade',
									storeId: item?.storeId,
									advanceBill: !item?.parentRowId,
									totalAmount:
											item?.finalTransactionAmount -
											item?.currentAmount,
									parentId: item?.id,
									vendorId: item?.vendorId,
									orderId: item?.orderId,
									isAdvance: !item?.parentRowId,
								});
							}}
							variant='contained'
							color='primary'
							fullWidth
						>
							Pay
						</Button>
					)} */}
					{isTransactionRejected && (
						<Button
							onClick={() => {
								toggleFileUploaderModal(true, {
									heading: 'Upload Invoice',
									selectedFile: '',
									confirmText: 'Upload',
									id,
								});
							}}
							variant='outline'
							className='w-full'
						>
							Re-Upload Invoice
						</Button>
					)}
					{
						(!isTransactionRejected && (userRoles.includes('finance') || isInternal) && levels?.includes(level) && !!grnBillApproval) ? <>
							{
								['APPROVAL_PENDING_FINANCE']?.includes(item?.transactionStatus) && <Button
									onClick={() => {

										pushPoInformation(item, vendorDetails);
									}}
									className='primary-btn w-full'
								>
									Finance Approval
								</Button>
							}
						</> : null
					}
					{levels.includes(level) && (userRoles.includes('procurement') || userRoles.includes('cityhead')) &&
						['APPROVAL_PENDING_MANAGER']?.includes(item?.transactionStatus) && <Button
							onClick={() => {

								pushPoInformation(item, vendorDetails);
							}}
							className={`${creditDocUploadPending ? 'text-red-500 bg-transparent pointer-events-none' : 'primary-btn'} w-full`}
						>
							{
								creditDocUploadPending ? 'Credit Doc upload pending' : 'Manager Approval (Pending)'
							}
						</Button>
					}
					{((isTransactionRejected || isTransactionCancelled) || item?.transactionStatus === 'APPROVAL_PENDING_MANAGER' || (!grnBillApproval && item?.transactionStatus === 'APPROVAL_PENDING_FINANCE')) && (
						<Button
							onClick={() => {
								const url = `${urls.EXTENSION}${urls.BILLS}/add?billId=${id}&isEdit=true&orderType=${item?.subType}`;
								history.push(url);
							}}
							variant='outline'
						>
							Edit {creditDocUploadPending ? '/ (Upload Doc)' : ''}
						</Button>
					)}
					{!userPermissions.MANAGER && (
						<p>Not approved</p>
					)}
					{['APPROVAL_PENDING_MANAGER', 'REJECTED'].includes(
						item?.transactionStatus
					) && (
							<Button
								onClick={() => {
									toggleAlert(true, {
										heading: `Cancel Bill ${item?.clientTransactionId}`,
										handleConfirm: () => {
											handleCancelBill(item);
											toggleAlert(false);
										},
										colorReverse: false,
										cancelText: 'No',
										confirmText: 'Yes',
										message: `Are you sure you want to Cancel Payment: ${item?.clientTransactionId || ''
											}?`,
										width: '28rem',
									});
								}}
								className='danger-btn w-full'
							>
								Cancel
							</Button>
						)}
				</div>
			);
		},
	};

	return (
		<div className={styles.root}>
			<ListTable
				showBtnContainer={showBtnContainer}
				allowExport={!hideExport}
				allowCheckList={allowCheckList}
				selectedRows={selectedBills}
				setSelectedRow={setSelectedBills}
				colMap={COLMAP}
				columns={TABLE_COLUMNS?.filter((ele) => {
					return !excludedColumns?.includes(ele?.title);
				})}
				data={BILLS?.map((ele) => {
					return {
						...ele,
						rowStyles: classes(
							styles.row,
							styles?.[ele?.transactionStatus]
						),
					};
				})}
				showTotal={showTotal}
				renderBtns={() => {
					return (
						<div>
							{!!selectedBills?.length && (
								<Button
									onClick={handleBulkPayment}
									variant='contained'
									color='primary'
								>
									Bulk payment
								</Button>
							)}
						</div>
					);
				}}
				// data={dummyData}
				actions={[...getActionColumn(BASE_COLUMNS, ADDITIONAL_COLUMNS, level, false, true, orderColumns), ...externalColumns]?.filter(
					(ele) => {
						return !excludedColumns?.includes(ele?.title);
					}
				)}
				special={{
					...SPECIAL_ITEMS,
					...externalSpecialItems,
				}}
				moreOptionsList={moreOptionsList}
				viewMoreOptionsList={viewMoreOptionsList}
			/>
		</div>
	);
};


const mapStateToProps = (state) => {
	const { userList } = state.auth;
	return {
		userList,
	};
};
const mapDispatchToProps = {
	fetchUserList: authActions?.fetchUserList,
};

export default connect(mapStateToProps, mapDispatchToProps)(BillsListing);
